import { render, staticRenderFns } from "./LampConcentratorInfo.vue?vue&type=template&id=467c3047"
import script from "./LampConcentratorInfo.vue?vue&type=script&lang=js"
export * from "./LampConcentratorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports